import * as moment from "moment";

export class DataNascimentoMinima {
    dataNascimentoValida(dataNascimento:string):boolean
    {
        const nascimento = moment(dataNascimento, "DDMMYYYY");
        const dataMinima = moment([moment().year(), 0, 1]).add(-130, 'y');
        return nascimento.isSameOrAfter(dataMinima) && nascimento.isSameOrBefore(moment());
    }

    dataNascimentoMaxima(dataNascimento:string)
    {
        const nascimento = moment(dataNascimento, "DDMMYYYY");
        const dataAtual = moment();
        return dataAtual.year() - nascimento.year();
    }

    dataValida(dataNascimento:string){
        const nascimento = moment(dataNascimento, "DDMMYYYY");
        const dataAtual = moment();
        if(nascimento > dataAtual){
            return false;
        }else{ 
            return true;
        }
    }
}
